import * as React from "react"
import {
  type EntityCategory,
  type EntityTransaction,
} from "@digits-graphql/frontend/graphql-bearer"
import { LoadingBlock } from "@digits-shared/components/Loaders"
import { EditableCategoryCell } from "src/frontend/components/Shared/Transactions/TableCells/EditableCategoryCell"
import { isTransaction } from "src/frontend/components/Shared/Transactions/types"
import { useTransactionsUpdates } from "src/frontend/components/Shared/Transactions/Updates/TransactionsUpdatesContext"

export const CategoryCell: React.FC<{ transaction: EntityTransaction }> = ({ transaction }) => {
  const { allowInlineUpdates, getTransactionUpdate, updateTransaction } = useTransactionsUpdates()
  const updatedCategory = getTransactionUpdate(transaction.factId)?.category

  const onCategorySelected = React.useCallback(
    (category: EntityCategory) => {
      if (!transaction.factId || !isTransaction(transaction)) return
      updateTransaction({ transaction, category })
    },
    [transaction, updateTransaction]
  )

  return (
    <EditableCategoryCell
      transaction={transaction}
      updatedCategory={updatedCategory}
      onCategorySelected={onCategorySelected}
      closedTimestamp={undefined}
      editable={allowInlineUpdates}
    />
  )
}

export const LoadingCategoryCell: React.FC = () => <LoadingBlock width="100%" height="20px" />
